export interface AdminAccess {
  kind: 'superadmin' | 'staff' | 'user';
  isSuperAdmin: boolean;
  hasAdminAccess: boolean;
  roleId: string;
  roleName: string;
  permissions: string[];
  staffVersion: number;
  roleVersion: number;
}

export const adminModules: Record<string, string> = {
  dashboard: 'dashboard', notifications: 'notifications', shipping: 'shipping',
  orders: 'orders', gemfinder: 'gemfinder', products: 'products', inventory: 'inventory', followups: 'followups',
  bestsellers: 'bestsellers', offers: 'offers', 'bracelet-gift': 'gifts',
  blogs: 'blogs', videos: 'videos', banners: 'banners',
  'app-promotion': 'appPromotion', reviews: 'reviews', coupons: 'coupons',
  'recent-purchases': 'recentPurchases',
};

export const moduleForPath = (pathname: string): string | null => {
  const segment = pathname.split('/')[2];
  return segment ? adminModules[segment] || null : null;
};

export const firstAdminPath = (access: AdminAccess): string => {
  if (access.isSuperAdmin) return '/admin/dashboard';
  const permission = Object.entries(adminModules).find(([, module]) => access.permissions.includes(`${module}.view`));
  return permission ? `/admin/${permission[0]}` : '/';
};
